import { useContext } from 'react';
import { AlertNotificationContext } from './AlertNotificationProvider';

const useAlertNotification = () => {
  const { notify } = useContext(AlertNotificationContext);

  return notify;
};

export default useAlertNotification;
